import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../componentes/Plantilla/Plantilla';
import styles from './LegalPages.module.css';

export const AvisoPrivacidad = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <div className={styles.legalContainer}>
        <div className={styles.legalHeader}>
          <h1 className={styles.legalTitle}>Aviso de Privacidad</h1>
          <div className={styles.lineaTitulo}></div>
        </div>

        <div className={styles.legalContent}>
          <p>
            <strong>Sistemas y Equipos Industriales y Medio Ambiente (SEIMA)</strong>, con domicilio en Blvd. los Próceres 19-08, Ciudad de Guatemala, Guatemala 01010, es el responsable del uso y protección de sus datos personales, y al respecto le informamos lo siguiente:
          </p>

          <h2>1. ¿Para qué fines utilizaremos sus datos personales?</h2>
          <p>
            Los datos personales que recabamos de usted, los utilizaremos para las siguientes finalidades que son necesarias para el servicio que solicita:
          </p>
          <ul>
            <li>Proveer información técnica, cotizaciones y detalles sobre equipos de lavandería y limpieza industrial.</li>
            <li>Dar seguimiento a solicitudes de mantenimiento preventivo y correctivo.</li>
            <li>Gestión administrativa, facturación y cobranza referente a los servicios y productos adquiridos.</li>
            <li>Envío de comunicaciones comerciales, actualizaciones de productos y promociones de marcas representadas (DOMUS, MAYTAG, entre otras), de manera eventual y sólo si usted no se opone a ello.</li>
          </ul>

          <h2>2. ¿Qué datos personales utilizaremos para estos fines?</h2>
          <p>
            Para llevar a cabo las finalidades descritas en el presente aviso de privacidad, utilizaremos los siguientes datos personales:
          </p>
          <ul>
            <li>Nombre completo y cargo dentro de la empresa que representa.</li>
            <li>Nombre o razón social de la empresa.</li>
            <li>Correo electrónico corporativo o personal proporcionado.</li>
            <li>Teléfono de contacto (fijo y/o móvil).</li>
            <li>Información sobre las necesidades técnicas o industriales requeridas en su proyecto.</li>
          </ul>

          <h2>3. ¿Con quién compartimos su información personal y para qué fines?</h2>
          <p>
            Le informamos que SEIMA <strong>no vende, alquila ni transfiere</strong> sus datos personales a terceros sin su consentimiento expreso, exceptuando aquellos casos en los que sea estrictamente necesario para cumplir con requerimientos legales o de autoridades competentes en la República de Guatemala. Toda información es manejada bajo estrictos estándares de confidencialidad comercial.
          </p>

          <h2>4. ¿Cómo puede acceder, rectificar o cancelar sus datos personales, u oponerse a su uso (Derechos ARCO)?</h2>
          <p>
            Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones del uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su información personal en caso de que esté desactualizada, sea inexacta o incompleta (Rectificación); que la eliminemos de nuestros registros o bases de datos (Cancelación); así como oponerse al uso de sus datos personales para fines específicos (Oposición).
          </p>
          <p>
            Para el ejercicio de cualquiera de los derechos ARCO, usted deberá presentar la solicitud respectiva enviando un correo electrónico a nuestro departamento de atención al cliente a través de los canales de contacto oficiales mencionados en este sitio web.
          </p>

          <h2>5. Cambios en el aviso de privacidad</h2>
          <p>
            El presente aviso de privacidad puede sufrir modificaciones, cambios o actualizaciones derivadas de nuevos requerimientos legales, de nuestras propias necesidades por los productos o servicios que ofrecemos, o por nuestras prácticas de privacidad. Nos comprometemos a mantenerlo informado sobre los cambios que pueda sufrir el presente aviso de privacidad mediante la publicación en esta misma página web.
          </p>

          <p style={{ marginTop: '40px', fontSize: '0.9rem', color: 'rgba(255,255,255,0.4)' }}>
            <strong>Última actualización:</strong> Junio de 2026.
          </p>
        </div>

        <div className={styles.legalFooter}>
          <Link to="/" className={styles.regresarBtn}>
            ← Regresar al Inicio
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default AvisoPrivacidad;
